module.exports = __webpack_public_path__ + "img/tools.a4e6a31f.svg";